<template>
  <div class="contact-form">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.is') }}</option>
      <option :value='false'>{{ $t('root.filters.is_not') }}</option>
    </select>

    <label>{{ $t('contacts.communication_status') }}</label>

    <div class="form-group form-inline communication-filter">
      <label v-for="color in ['gray', 'green', 'yellow', 'red']" :key='color'>
        <input type="checkbox" v-model='modelFilterStatus' :value='color' v-on:keydown.enter.prevent="filter" />
        <img :src="require(`../../../assets/${color}-env.png`)" />
      </label>
    </div>

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>

export default {
  created() {
    this.listStore.getContacts()
  },
  data() {
    return {
      predicate: true,
      modelFilterStatus: []
    }
  },
  computed: {
    predicateQuery() {
      return this.predicate ? 'filters[contact_data_status_in]' : 'filters[contact_data_status_not_in]'
    }
  },
  methods: {
    filter() {
      let newQuery = Object.assign({}, this.query)

      delete newQuery['filters[contact_data_status_in]']
      delete newQuery['filters[contact_data_status_not_in]']

      newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.modelFilterStatus })

      this.$router.push({ query: newQuery })
    }
  }
}
</script>

<style lang="sass" scoped>
.contact-form
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
.form-inline
  label
    margin-right: 10px
    &:first-child
      margin-right: 15px
  input
    margin: 0 3px 0 3px
</style>
